import React from "react";
import Image from "next/image";
import close from "assets/img/close.svg";
import { useTranslation } from "react-i18next";
type PropsType = {
  show: boolean;
  onClose: (show?: boolean) => void;
  children?: any;
  width?: string;
  closeIconCoordinates?: string;
  maxHeight?: string;
  bgColor?: string;
  height?: string;
};

const Model: React.FC<PropsType> = ({
  show,
  onClose,
  children,
  width,
  closeIconCoordinates,
  maxHeight,
  height,
  bgColor = "bg-white",
}) => {
  const { t, i18n } = useTranslation();

  return (
    <div
      style={{
        fontFamily: `${i18n.language === "en" ? "Baloo-regular" : "Almarai "} `,
        zIndex: 1000000000,
      }}
      className={`${show ? "" : "hidden"} w-full h-full   `}
    >
      <div className={` flex items-center justify-center w-full h-full `}>
        <div
          className={` shadow-xl py-3 bg-white px-9 rounded-md    ${bgColor} ${
            width ? width : "w-96"
          } ${height}`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Model;
